import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
/* import { Link } from 'react-router-dom';
import { Menu } from 'antd'; */
import { useLocation, useNavigate as useHistory } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { LinkContainer } from 'react-router-bootstrap';

function NavBarNew({ resetCounter, setResetCounter }) {
  const { t } = useTranslation();

  const [current, setCurrent] = useState();
  const [menuClicked, setMenuClicked] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [previousPage, setPreviousPage] = useState(null);

  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const page = location.pathname.split('/')[1];
    setPreviousPage(page);

    const path = '/' + page;
    setCurrent(path);

    var links = document.getElementsByClassName('new-nav-link');
    Array.prototype.forEach.call(links, function (link) {
      link.setAttribute('aria-current', '');
    });
    document.getElementsByClassName('active-link')[0]?.classList.remove('active-link');

    document
      .querySelector(`[href='${process.env.REACT_APP_PREFIX + path}']`)
      ?.classList.add('active-link');
    document
      .querySelector(`[href='${process.env.REACT_APP_PREFIX + path}']`)
      ?.setAttribute('aria-current', 'page');
  }, [location]);

  const handleNavItemClick = (currentPage) => {
    if (!menuClicked) {
      document.getElementById('basic-navbar-nav').classList.remove('show');
      setMenuClicked(true);
    }

    if (previousPage && previousPage === currentPage){
      setResetCounter(resetCounter + 1);
    }
    else{
      setResetCounter(1);
    }

    //evt.preventDefault();
    //let path = '' + evt.target.getAttribute('href');
    //path = path.substr(process.env.REACT_APP_PREFIX.length);
    //history(path);
  };

  return (
    <Navbar expanded={expanded} name="menù principale" expand="lg" className="nav-bg" variant="dark" onSelect={() => setExpanded(false)}>
      <div className="nav-container">
        <Navbar.Toggle onClick={() => setExpanded(!expanded)} aria-controls="basic-navbar-nav" label={expanded ? 'Chiudi menù principale' : 'Apri menù principale'} />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto" role="list">
            <Nav.Link
              role="listitem"
              key="nav-link-home"
              href={`${process.env.REACT_APP_PREFIX}/home`}
              className="new-nav-link"
              tabIndex={0}
              onClick={() => {handleNavItemClick('home')}}>
              {t('menu.home')}
            </Nav.Link>
            <Nav.Link
              role="listitem"
              key="nav-link-territorio"
              href={`${process.env.REACT_APP_PREFIX}/territorio`}
              className="new-nav-link"
              tabIndex={0}
              onClick={() => {handleNavItemClick('territorio')}}>
              {t('menu.territory')}
            </Nav.Link>
            <Nav.Link
              role="listitem"
              key="nav-link-variazioni"
              href={`${process.env.REACT_APP_PREFIX}/variazioni`}
              className="new-nav-link"
              tabIndex={0}
              onClick={() => {handleNavItemClick('variazioni')}}>
              {t('menu.variations')}
            </Nav.Link>
            <Nav.Link
              role="listitem"
              key="nav-link-ricostruzione-codici"
              href={`${process.env.REACT_APP_PREFIX}/ricostruzione-codici`}
              className="new-nav-link"
              tabIndex={0}
              onClick={() => {handleNavItemClick('ricostruzione-codici')}}>
              {t('menu.updates')}
            </Nav.Link>
            <Nav.Link
              role="listitem"
              key="nav-link-storia-ua"
              href={`${process.env.REACT_APP_PREFIX}/storia_ua`}
              className="new-nav-link"
              tabIndex={0}
              onClick={() => {handleNavItemClick('storia_ua')}}>
              {t('menu.storia_ua')}
            </Nav.Link>
            <Nav.Link
              role="listitem"
              key="nav-link-ricerca-codice"
              href={`${process.env.REACT_APP_PREFIX}/ricerca-codice`}
              className="new-nav-link"
              tabIndex={0}
              onClick={() => {handleNavItemClick('ricerca-codice')}}>
              {t('menu.ter_research')}
            </Nav.Link>
            {/* FASE 3 - PAGINA DOWNLOAD OSCURATA
            <Nav.Link
              role="listitem"
              key="nav-link-download"
              href={`${process.env.REACT_APP_PREFIX}/download`}
              className="new-nav-link"
              tabIndex={0}
              onClick={() => {handleNavItemClick('download')}}>
              {t('menu.download')}
            </Nav.Link>
             */}
            <Nav.Link
              role="listitem"
              key="nav-link-glossario"
              href={`${process.env.REACT_APP_PREFIX}/glossario`}
              className="new-nav-link"
              tabIndex={0}
              onClick={() => {handleNavItemClick('glossario')}}>
              {t('menu.glossario')}
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
  // eslint-disable-next-line no-unreachable
  {
    /* <div className="custom-nav-container w-100 d-flex justify-content-center">
      <Menu onClick={({ key }) => setCurrent(key)} selectedKeys={[current]} mode="horizontal">
        <Menu.Item key="home">
          <Link className="nav-link" to="/*">
            {t('menu.home')}{' '}
          </Link>
        </Menu.Item>
        <Menu.Item key="territorio">
          <Link className="nav-link" to="/territorio">
            {t('menu.territory')}{' '}
          </Link>
        </Menu.Item>
        <Menu.Item key="variazioni">
          <Link className="nav-link" to="/variazioni">
            {t('menu.variations')}
          </Link>
        </Menu.Item>
        <Menu.Item key="ricostruzione-codici">
          <Link className="nav-link" to="/ricostruzione-codici">
            {t('menu.updates')}{' '}
          </Link>
        </Menu.Item>
        <Menu.Item key="storia_ua">
          <Link className="nav-link" to="/storia_ua">
            {t('menu.storia_ua')}
          </Link>
        </Menu.Item>
        <Menu.Item key="ricerca-codice">
          <Link className="nav-link" to="/ricerca-codice">
            {t('menu.ter_research')}
          </Link>
        </Menu.Item>
        <Menu.Item key="download">
          <Link className="nav-link" to="/download">
            {t('menu.download')}
          </Link>
        </Menu.Item>
        <Menu.Item key="glossario">
          <Link className="nav-link" to="/glossario">
            {t('menu.glossario')}
          </Link>
        </Menu.Item>
      </Menu>
    </div> */
  }
}

export default NavBarNew;
